




import { useState,useEffect } from "react";
import { applyLeaveApi,getLeaveTypesApi } from "../../app/api";
import { toast } from "react-toastify";
import {
  Briefcase,
  Clock,
  Zap,
  Home,
  Calendar,
  MessageSquare,
  CheckCircle2,
  X,
  Smile,
  DollarSign
} from "lucide-react";
import EmojiPicker from "emoji-picker-react";
 
export default function ApplyLeave() {

  const [leaveTypes, setLeaveTypes] = useState([]);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const user = JSON.parse(localStorage.getItem("user"));
  const [showEmoji, setShowEmoji] = useState(false);
  const isMobile = window.innerWidth < 768;
 
  const [form, setForm] = useState({
    leave_type_id: "",
    leave_start_date: "",
    leave_end_date: "",
    duration: 0,
    employee_comment: "",
  });
  const [errors, setErrors] = useState({});
 
  const [submitting, setSubmitting] = useState(false);
 
  // const leaveTypes = [
  //   { id: 1, name: "Casual Leave", icon: <Briefcase className="w-5 h-5" />, color: "from-blue-500 to-cyan-400" },
  //   { id: 4, name: "Half Day", icon: <Clock className="w-5 h-5" />, color: "from-purple-500 to-pink-400" },
  //   { id: 6, name: "Short Leave", icon: <Zap className="w-5 h-5" />, color: "from-yellow-500 to-orange-400" },
  //   { id: 5, name: "Work From Home", icon: <Home className="w-5 h-5" />, color: "from-green-500 to-emerald-400" },
  // ];



  const iconMap = {
    "Casual": <Briefcase size={20} />,
    "Half Day": <Clock size={20} />,
    "Short Leave": <Zap size={20} />,
    "Work From Home": <Home size={20} />,
    "Unpaid Leave": <DollarSign size={20} />
  };


  const allowedTypes = [
    "Casual",
    "Short Leave",
    "Half Day",
    "Work From Home",
    "Unpaid Leave"
  ];



  const fetchLeaveTypes = async () => {
    try {
      const res = await getLeaveTypesApi();
  
      if (res?.success) {
        const filtered = res.data.filter(t =>
          allowedTypes.includes(t.leave_type)
        );
  
        setLeaveTypes(
          filtered.map(t => ({
            ...t,
            name: t.leave_type === "Unpaid Leave" ? "Leave Without Pay [LWP]" : t.leave_type, // Updated display name
            icon: iconMap[t.leave_type] || <Briefcase size={20} />,
            color: "from-blue-500 to-cyan-400" // optional fallback
          }))
        );
      }
    } catch (err) {
      console.error("Failed to fetch leave types:", err);
    }
  };
 
  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
    if (errors[name]) setErrors(prev => ({ ...prev, [name]: null }));
 
    if (name === "leave_start_date" || name === "leave_end_date") {
      const start = name === "leave_start_date" ? value : form.leave_start_date;
      const end = name === "leave_end_date" ? value : form.leave_end_date;
 
      if (start && end) {
        const s = new Date(start);
        const eDate = new Date(end);
        const diff = (eDate - s) / (1000 * 60 * 60 * 24) + 1;
        setForm((prev) => ({ ...prev, duration: diff > 0 ? diff : 0 }));
      }
    }
  };
 
  const submitLeave = async () => {
    if (!user?.id) return toast.error("User not logged in");
    if (!form.leave_type_id) return toast.error("Select leave type");
    if (!form.leave_start_date) return toast.error("Select start date");
    if (!form.leave_end_date) return toast.error("Select end date");
    if (!form.employee_comment) {
      setErrors(prev => ({ ...prev, employee_comment: "Reason is required" }));
      return toast.error("Reason is required");
    }
 
    setSubmitting(true);
    const res = await applyLeaveApi({
      ...form,
      employee_id: user.id,
    });
 
    if (res.success) {
      window.dispatchEvent(new CustomEvent("leave-updated"));
      setShowSuccessModal(true);
      setForm({
        leave_type_id: "",
        leave_start_date: "",
        leave_end_date: "",
        duration: 0,
        employee_comment: "",
      });
    } else {
      toast.error(res.message || "Failed to apply leave");
    }
    setSubmitting(false);
  };




  useEffect(() => {
    fetchLeaveTypes();
  }, []);
 
  return (
    <div className="max-w-7xl mx-auto md:mt-20">
      <div className="
        relative overflow-hidden
        rounded-[32px] p-8 md:p-10
        bg-gradient-to-br from-[#1e174a] to-[#0f0c29]
        backdrop-blur-2xl text-white
        border border-white/10
        shadow-[0_40px_100px_-20px_rgba(0,0,0,0.7)]
      ">
        {/* Background Accents */}
        <div className="absolute -top-24 -right-24 w-96 h-96 bg-blue-600/20 blur-[100px] rounded-full pointer-events-none" />
        <div className="absolute -bottom-24 -left-24 w-96 h-96 bg-purple-600/20 blur-[100px] rounded-full pointer-events-none" />
 
        <div className="relative z-10">
          <div className="flex items-center gap-4 mb-10">
            <div className="p-3.5 rounded-2xl bg-gradient-to-br from-blue-500 to-indigo-600 shadow-lg shadow-blue-500/20">
              <Calendar className="w-8 h-8 text-white" />
            </div>
            <div>
              {/* <h1 className="text-3xl font-black tracking-tight">Apply for Leave</h1> */}

              <h1 className="text-3xl font-semibold text-white">
              Apply for Leave
        </h1>
              <p className="text-white/60 text-sm">Request time off and track your status</p>
            </div>
          </div>
 
          <div className="space-y-8">
            {/* Leave Type Selector */}
            <div>
              <label className="text-[12px] font-semiboldtracking-widest text-white/70 ml-1 mb-3 block">
                Select Leave Category
              </label>
              <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
                {leaveTypes.map((t) => (
                  <button
                    key={t.id}
                    disabled={submitting}
                    onClick={() => setForm((p) => ({ ...p, leave_type_id: t.id }))}
                    className={`
                      relative group flex flex-col items-center justify-center p-5 rounded-2xl transition-all duration-300
                      border ${form.leave_type_id === t.id ? 'border-transparent' : 'border-white/10 hover:border-white/20 bg-white/5'}
                    `}
                  >
                    {form.leave_type_id === t.id && (
                      <div className={`absolute inset-0 rounded-2xl bg-gradient-to-br ${t.color} opacity-20 shadow-inner`} />
                    )}
                    <div className={`
                      mb-3 p-3 rounded-xl transition-all duration-300
                      ${form.leave_type_id === t.id ? 'bg-white text-black scale-110' : 'bg-white/5 text-blue-300 group-hover:scale-110'}
                    `}>
                      {t.icon}
                    </div>
                    <span className={`text-xs font-bold transition-all duration-300 ${form.leave_type_id === t.id ? 'text-white' : 'text-white/60 group-hover:text-white'}`}>
                      {t.name}
                    </span>
                  </button>
                ))}
              </div>
            </div>
 
            {/* Date Range & Duration */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-2 md:gap-4 items-end">
              <div className="space-y-2">
                <label className="text-[12px] font-semibold tracking-widest text-white/70 ml-1">
                  Start Date
                </label>
                <div className="relative">
                  <Calendar className="absolute left-4 top-1/2 -translate-y-1/2 w-4 h-4 text-white/30" />
                  <input
                    type="date"
                    name="leave_start_date"
                    onChange={handleChange}
                    value={form.leave_start_date}
                    className="w-full bg-white/5 border border-white/10 rounded-2xl px-11 py-3.5 text-sm outline-none transition focus:border-blue-500/50 focus:bg-white/[0.08]"
                  />
                </div>
              </div>
 
              <div className="space-y-2">
                <label className="text-[12px] font-semibold  tracking-widest text-white/70 ml-1">
                  End Date
                </label>
                <div className="relative">
                  <Calendar className="absolute left-4 top-1/2 -translate-y-1/2 w-4 h-4 text-white/30" />
                  <input
                    type="date"
                    name="leave_end_date"
                    onChange={handleChange}
                    value={form.leave_end_date}
                    className="w-full bg-white/5 border border-white/10 rounded-2xl px-11 py-3.5 text-sm outline-none transition focus:border-blue-500/50 focus:bg-white/[0.08]"
                  />
                </div>
              </div>
 
              <div className="space-y-2">
                <label className="text-[12px] font-semibold tracking-widest text-white/70 ml-1">
                  Total Duration
                </label>
                <div className="relative">
                  <Clock className="absolute left-4 top-1/2 -translate-y-1/2 w-4 h-4 text-blue-400" />
                  <input
                    type="text"
                    value={`${form.duration} ${form.duration === 1 ? 'Day' : 'Days'}`}
                    disabled
                    className="w-full bg-blue-500/10 border border-blue-500/20 rounded-2xl px-11 py-3.5 text-sm font-bold text-blue-400"
                  />
                </div>
              </div>
            </div>
 
            {/* Reason Textarea */}
            <div className="space-y-2 relative">
              <label className="text-[12px] font-semibold tracking-widest text-white/70 ml-1">
                Reason for Leave
              </label>
              <div className="relative group">
                <div className="absolute left-4 top-5 text-white/30 group-focus-within:text-blue-400 transition">
                  <MessageSquare className="w-4 h-4" />
                </div>
                <textarea
                  name="employee_comment"
                  onChange={handleChange}
                  value={form.employee_comment}
                  placeholder="Tell us about your plans..."
                  className={`w-full min-h-[160px] bg-white/5 border ${errors.employee_comment ? 'border-red-500' : 'border-white/10'} rounded-[24px] px-11 py-5 text-sm outline-none transition focus:border-blue-500/50 focus:bg-white/[0.08] resize-none`}
                />
                {errors.employee_comment && (
                  <p className="text-red-500 text-[10px] mt-1 ml-1 animate-pulse">
                    * {errors.employee_comment}
                  </p>
                )}
                <button
                  type="button"
                  onClick={() => setShowEmoji(!showEmoji)}
                  className="absolute bottom-4 right-4 p-2 rounded-xl bg-white/5 hover:bg-white/10 transition text-xl"
                >
                  <Smile className="w-5 h-5 text-yellow-400" />
                </button>
              </div>
 
              {/* Emoji Picker Popover */}
              {showEmoji && (
                <div className={`absolute z-50 ${isMobile ? 'fixed inset-x-0 bottom-0 top-auto' : 'right-0 bottom-full mb-4'}`}>
                  {isMobile && (
                    <div className="fixed inset-0 bg-black/60 backdrop-blur-sm" onClick={() => setShowEmoji(false)} />
                  )}
                  <div className={`relative ${isMobile ? 'bg-[#1a0f4c] rounded-t-3xl p-4 h-[50vh]' : ''}`}>
                    {isMobile && (
                      <div className="flex justify-between items-center mb-4">
                        <span className="font-bold">Select Emoji</span>
                        <button onClick={() => setShowEmoji(false)} className="p-2 bg-white/10 rounded-full"><X className="w-4 h-4" /></button>
                      </div>
                    )}
                    <EmojiPicker
                      theme="dark"
                      width={isMobile ? "100%" : "350px"}
                      height={isMobile ? "calc(100% - 40px)" : "400px"}
                      onEmojiClick={(e) => {
                        setForm(p => ({ ...p, employee_comment: p.employee_comment + e.emoji }));
                        if (!isMobile) setShowEmoji(false);
                      }}
                    />
                  </div>
                </div>
              )}
            </div>
 
            {/* Submit Action */}
            <div className="pt-4">
              <button
                onClick={submitLeave}
                disabled={submitting}
                className="
                  w-full py-4 rounded-2xl font-black text-sm uppercase tracking-[3px]
                  bg-gradient-to-r from-blue-600 to-indigo-700
                  hover:from-blue-500 hover:to-indigo-600
                  transition-all duration-300 shadow-xl shadow-blue-900/40
                  flex items-center justify-center gap-3
                  disabled:opacity-50 disabled:cursor-not-allowed
                "
              >
                {submitting ? (
                  <div className="w-5 h-5 border-2 border-white/30 border-t-white rounded-full animate-spin" />
                ) : (
                  <>
                    <CheckCircle2 className="w-5 h-5" />
                    Submit Application
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
 
      {/* SUCCESS MODAL */}
      {/* {showSuccessModal && (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center p-4">
          <div className="absolute inset-0 bg-black/60 backdrop-blur-md" onClick={() => setShowSuccessModal(false)} />
          <div className="
            relative w-full max-w-md
            bg-gradient-to-br from-[#24155a] to-[#12082f]
            rounded-[40px] p-10 text-center
            border border-white/20 shadow-2xl animate-scaleIn
          ">
            <div className="flex justify-center mb-8">
              <div className="w-24 h-24 rounded-[32px] bg-green-500/20 flex items-center justify-center shadow-inner">
                <CheckCircle2 className="w-12 h-12 text-green-400" />
              </div>
            </div>
            <h3 className="text-3xl font-black mb-3">Leave Applied!</h3>
            <p className="text-white/50 text-base mb-10 leading-relaxed font-medium">
              Your request has been submitted and is awaiting manager approval.
            </p>
            <button
              onClick={() => {
                setShowSuccessModal(false);
                window.location.reload();
              }}
              className="
                w-full py-4 rounded-2xl font-bold bg-white text-black
                hover:bg-blue-300 transition shadow-xl
              "
            >
              Great, thanks!
            </button>
          </div>
        </div>
      )} */}




            {/* SUCCESS MODAL */}
{showSuccessModal && (
  <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/60 backdrop-blur-sm">
    <div className="
      w-[90%] max-w-md
      bg-gradient-to-br from-[#2d1c6a] to-[#12082f]
      rounded-2xl
      p-6
      text-white
      shadow-2xl
      animate-scaleIn
    ">
      {/* ICON */}
      <div className="flex justify-center mb-4">
        <div className="w-16 h-16 rounded-full bg-green-500/20 flex items-center justify-center text-3xl">
          ✅
        </div>
      </div>

      {/* TEXT */}
      <h3 className="text-xl font-semibold text-center mb-2">
        Leave Applied!
      </h3>

      <p className="text-center text-white/70 mb-6">
        Your leave request has been submitted successfully and is pending approval.
      </p>

      {/* ACTION */}
      {/* <button
        onClick={() => setShowSuccessModal(false)} */}
        <button
  onClick={() => {
    setShowSuccessModal(false);
  }}
       
        className="
          w-full py-3 rounded-lg
          bg-gradient-to-r from-[#110EFD] to-[#2DC6FD]
          font-medium
          hover:opacity-90
          transition
        "
      >
        Okay
      </button>
    </div>
  </div>
)}
    </div>
  );
}




// import { useState } from "react";
// import { applyLeaveApi } from "../../app/api";
// import { toast } from "react-toastify";
// import { Briefcase, Clock, Zap, Home } from "lucide-react";
// import EmojiPicker from "emoji-picker-react";

// export default function ApplyLeave() {
//   const [showSuccessModal, setShowSuccessModal] = useState(false);
//   const user = JSON.parse(localStorage.getItem("user"));
//   const [showEmoji, setShowEmoji] = useState(false);
//   const isMobile = window.innerWidth < 768;

//   const [form, setForm] = useState({
//     leave_type_id: "",
//     leave_start_date: "",
//     leave_end_date: "",
//     duration: 0,
//     employee_comment: "",
//   });

//   const [submitting, setSubmitting] = useState(false);

//   const leaveTypes = [
//     { id: 1, name: "Casual Leave", icon: <Briefcase size={20} /> },
//     { id: 4, name: "Half Day", icon: <Clock size={20} /> },
//     { id: 6, name: "Short Leave", icon: <Zap size={20} /> },
//     { id: 5, name: "Work From Home", icon: <Home size={20} /> },
//   ];



//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setForm((prev) => ({ ...prev, [name]: value }));

//     if (name === "leave_start_date" || name === "leave_end_date") {
//       const start = name === "leave_start_date" ? value : form.leave_start_date;
//       const end = name === "leave_end_date" ? value : form.leave_end_date;

//       if (start && end) {
//         const s = new Date(start);
//         const eDate = new Date(end);
//         const diff = (eDate - s) / (1000 * 60 * 60 * 24) + 1;
//         setForm((prev) => ({ ...prev, duration: diff > 0 ? diff : 0 }));
//       }
//     }
//   };

//   const submitLeave = async () => {
//     if (!user?.id) return toast.error("User not logged in");
//     if (!form.leave_type_id) return toast.error("Select leave type");
//     if (!form.leave_start_date) return toast.error("Select start date");
//     if (!form.leave_end_date) return toast.error("Select end date");

//     setSubmitting(true);

//     const res = await applyLeaveApi({
//       ...form,
//       employee_id: user.id,
//     });

//     // res.success
//     //   ? toast.success("Leave applied successfully!")
//     //   : toast.error(res.message || "Failed");



//     if (res.success) {
//       setShowSuccessModal(true);
//       setForm({
//         leave_type_id: "",
//         leave_start_date: "",
//         leave_end_date: "",
//         duration: 0,
//         employee_comment: "",
//       });
//     } else {
//       toast.error(res.message || "Failed");
//     }
    

//     setSubmitting(false);
//   };

//   return (
//     <div className="rounded-2xl p-6 md:mt-20 bg-gradient-to-br from-[#2d1c6a] via-[#24155a] to-[#12082f] text-white shadow-2xl w-full">
//       <h2 className="font-bold text-2xl mb-6">
//         Apply Leave
//       </h2>

//       {/* Leave Type */}
//       <p className="text-sm text-white/70 mb-2">
//         Leave Type
//       </p>

//       <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
//         {leaveTypes.map((t) => (
//           <div
//             key={t.id}
//             onClick={() =>
//               !submitting &&
//               setForm((p) => ({ ...p, leave_type_id: t.id }))
//             }
//             className={`
//               p-3 rounded-lg text-center cursor-pointer transition
//               border border-white/10
//               ${
//                 form.leave_type_id === t.id
//                   ? "bg-white text-black shadow-lg"
//                   : "bg-white/10 hover:bg-white/20"
//               }
//             `}
//           >
//             <div className="flex justify-center mb-1 text-blue-300">
//               {t.icon}
//             </div>
//             <div className="text-sm font-medium">
//               {t.name}
//             </div>
//           </div>
//         ))}
//       </div>

//       {/* Dates */}
//       <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
//         <div>
//           <p className="text-xs text-white/60 mb-1">
//             Start Date
//           </p>
//           <input
//             type="date"
//             name="leave_start_date"
//             onChange={handleChange}
//             value={form.leave_start_date}
//             className="w-full p-3 rounded bg-white/10"
//           />
//         </div>

//         <div>
//           <p className="text-xs text-white/60 mb-1">
//             End Date
//           </p>
//           <input
//             type="date"
//             name="leave_end_date"
//             onChange={handleChange}
//             value={form.leave_end_date}
//             className="w-full p-3 rounded bg-white/10"
//           />
//         </div>
//       </div>

//       {/* Duration */}
//       <div className="mb-4">
//         <p className="text-xs text-white/60 mb-1">
//           Duration (days)
//         </p>
//         <input
//           type="number"
//           value={form.duration}
//           disabled
//           className="w-full p-3 rounded bg-white/10 text-blue-300 font-semibold"
//         />
//       </div>

//       {/* Reason + Emoji */}
//       <div className="mb-6 relative">
//         <p className="text-xs text-white/60 mb-1">
//           Reason
//         </p>

//         <textarea
//           name="employee_comment"
//           onChange={handleChange}
//           value={form.employee_comment}
//           className="emoji-support w-full p-4 rounded bg-white/10 min-h-[140px]"
//           placeholder="Write your reason..."
//         />

//         <button
//           type="button"
//           onClick={() => setShowEmoji(true)}
//           className="absolute bottom-3 right-3 text-xl"
//         >
//           😊
//         </button>

//         {/* DESKTOP POPOVER */}
//      {/* DESKTOP POPOVER */}
// {!isMobile && showEmoji && (
//   <div className="absolute right-0 bottom-14 z-50">
//     <div className="relative">
//       {/* CLOSE BUTTON */}
//       <button
//         onClick={() => setShowEmoji(false)}
//         className="
//           absolute -top-3 -right-3
//           bg-red-500 text-white
//           w-7 h-7 rounded-full
//           flex items-center justify-center
//           text-sm font-bold
//           z-[9999]
//           shadow-lg
//         "
//       >
//         ✕
//       </button>

//       {/* EMOJI PICKER */}
//       <div className="z-50">
//         <EmojiPicker
//           onEmojiClick={(e) =>
//             setForm((prev) => ({
//               ...prev,
//               employee_comment:
//                 prev.employee_comment + e.emoji,
//             }))
//           }
//           theme="dark"
//         />
//       </div>
//     </div>
//   </div>
// )}


//         {/* MOBILE BOTTOM SHEET */}
//         {isMobile && showEmoji && (
//           <div className="fixed inset-0 bg-black/20 z-50 flex items-end">
// <div className="
//   w-full
//   rounded-t-2xl
//   p-3
//   h-[70vh]
//   bg-white/15
//   backdrop-blur-2xl
//   border border-white/30
//   shadow-[0_20px_60px_rgba(0,0,0,0.6)]
// ">


//               <div className="flex justify-between items-center mb-2">
//                 <span className="text-sm">
//                   Pick Emoji
//                 </span>
//                 <button
//                   onClick={() => setShowEmoji(false)}
//                 >
//                   ✕
//                 </button>
//               </div>

//               <EmojiPicker
//                width="100%"
//   height="100%"
//                 onEmojiClick={(e) =>
//                   setForm((prev) => ({
//                     ...prev,
//                     employee_comment:
//                       prev.employee_comment + e.emoji,
//                   }))
//                 }
//                 theme="dark"
//               />
//             </div>
//           </div>
//         )}
//       </div>

//       {/* Submit */}
//       <button
//         onClick={submitLeave}
//         disabled={submitting}
//         className="w-full py-3 rounded-lg bg-gradient-to-r from-[#110EFD] to-[#2DC6FD] text-lg font-medium hover:opacity-90 transition"
//       >
//         {submitting ? "Applying..." : "Apply Leave"}
//       </button>









//       {/* SUCCESS MODAL */}
// {showSuccessModal && (
//   <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/60 backdrop-blur-sm">
//     <div className="
//       w-[90%] max-w-md
//       bg-gradient-to-br from-[#2d1c6a] to-[#12082f]
//       rounded-2xl
//       p-6
//       text-white
//       shadow-2xl
//       animate-scaleIn
//     ">
//       {/* ICON */}
//       <div className="flex justify-center mb-4">
//         <div className="w-16 h-16 rounded-full bg-green-500/20 flex items-center justify-center text-3xl">
//           ✅
//         </div>
//       </div>

//       {/* TEXT */}
//       <h3 className="text-xl font-semibold text-center mb-2">
//         Leave Applied!
//       </h3>

//       <p className="text-center text-white/70 mb-6">
//         Your leave request has been submitted successfully and is pending approval.
//       </p>

//       {/* ACTION */}
//       {/* <button
//         onClick={() => setShowSuccessModal(false)} */}
//         <button
//   onClick={() => {
//     setShowSuccessModal(false);
//     window.location.reload();
//   }}
       
//         className="
//           w-full py-3 rounded-lg
//           bg-gradient-to-r from-[#110EFD] to-[#2DC6FD]
//           font-medium
//           hover:opacity-90
//           transition
//         "
//       >
//         Okay
//       </button>
//     </div>
//   </div>
// )}

//     </div>
//   );
// }
